module.exports = __webpack_public_path__ + "img/Hawaiian_Meal_Maui_Chicken.42948055.jpg";